module.exports = __webpack_public_path__ + "img/shape-9-mobile@2x.8d19bc92.png";